<template lang="pug">
.jumbotron.jumbotron-fluid.text-white.bg-dark.mb-0(
  :style="{ backgroundImage: 'url(' + background + ')' }"
)
  .container
    .title.text-center.p-3
      h4.display-4.text-white.mb-4 {{ title }}
      a.btn.btn-warning.text-white(@click="btnClick") {{ btnName }}
</template>

<script>
import { mixins } from "@/mixins/mixins.js";

export default {
  name: "TopBanner",
  mixins: [mixins],
  props: {
    background: String,
    btnName: String,
    url: Object,
    title: String,
  },
  methods: {
    btnClick() {
      this.linkClick(this.url);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/common/top_banner";
</style>
